import {Pipe, PipeTransform} from '@angular/core';
import {UserProfileService} from '@ui-app/services/user-profile.service';

@Pipe({
    name: 'byRole'
})
export class ByRolePipe implements PipeTransform {
    constructor(private userProfileService: UserProfileService) {
    }

    transform(roles: number[], ...args: unknown[]): unknown {
        if (roles && roles.length) {
            const user = this.userProfileService.user;
            if (user?.userRoleIds?.length) {
                return user.userRoleIds.some(id => roles.includes(id));
            }
            const userRoleId = args.length > 0 && args[0] !== undefined
                ? args[0] as number
                : user?.userRoleId;
            return roles.includes(userRoleId);
        } else {
            return true;
        }
    }

}
